import API from '..';
const ENTITY = 'products';

export const createItem = (data) => API.post(`/api/v1/${ENTITY}/`, data);

export const getItem = (id) => API.get(`/api/v1/${ENTITY}/${id}/`);

export const getItems = ({
    orderBy,
    page = 1,
    perPage = 25,
    searchText,
    sortBy,
    status = 'active',
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            page: page,
            per_page: perPage,
            status_flag: status,
            ...(orderBy ? { order_by: orderBy } : {}),
            ...(searchText ? { search: searchText } : {}),
            ...(sortBy ? { sort: sortBy } : {}),
        },
    });

export const updateItem = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}/`, data);

export const deleteItem = (id) => API.delete(`/api/v1/${ENTITY}/${id}/`);

export const bulkItems = (data) =>
    API.put(
        `/api/v1/${ENTITY}/bulk-status/`,
        { ...data },
        { headers: { 'Content-Type': 'application/json' } },
    );

export const getCatalog = () => API.get(`/api/v1/${ENTITY}/catalog/`);
